import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const TimeSpanIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM16 13H11.442C11.161 13 10.892 12.882 10.703 12.674L5.983 7.496C5.798 7.293 5.784 6.977 5.963 6.77C7.313 5.211 9.25 4.175 11.43 4.02C11.74 3.998 12 4.259 12 4.57V11H16C16.552 11 17 11.448 17 12C17 12.552 16.552 13 16 13Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

TimeSpanIcon.propTypes = {
  sx: PropTypes.object,
};

export default TimeSpanIcon;
